import { iconsSet } from "../../../../assets/icons/icons";
import defaultContent from "../default";
export default {
  hero: {
    img: {
      url: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_poupabot.png",
      alt: "Estratégias PoupaBot",
    },
    title: "Nossa tecnologia trabalhando para você!",

    // String ou array de strings
    text: "Chegou a hora de você ser um investidor de sucesso, alcançando a tão sonhada consistência e liberdade financeira operando com a PoupaBot.",
    testimonial: {
      text: "O grande diferencial das nossas estratégias é a alta capacidade de adaptação a qualquer ciclo do mercado. Nossa tecnologia permite que o usuário tenha consistência nos ganhos e tranquilidade para investir.",
      author: {
        name: "Sérgio Lemos, Head de Estratégias da PoupaBot",
        picture:
          "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/sergio_lemos_profile.PNG",
      },
    },
  },
  strategies: {
    title: "Estratégias PoupaBot",
    heading: "Rentabilidade, consistência e controle emocional!",
    subtitle:
      "Conheça nossas estratégias vencedoras. Você está a alguns cliques do sucesso!",
  },
  cta: {
    title: "Pronto para iniciar?",
    subtitle: "Ative agora mesmo a extensão PoupaBot.",
  },
  about: {
    title: "Sobre o desenvolvedor",
    subtitle: "A PoupaBot",
    col1: [
      "Construída por traders com mais de 14 anos de experiência no mercado financeiro brasileiro e internacional, a PoupaBot nasceu com um propósito: usar a tecnologia para facilitar a vida dos investidores.",
    ],
    col2: [
      "Com algoritmos quantitativos proprietários e o que tem de mais moderno no campo da Inteligência Artificial, realizamos constantes validações, gerando maior segurança e adaptação aos ciclos do mercado, dessa forma conseguimos proporcionar para você o que realmente importa no mundo dos investimentos: Rentabilidade, Consistência e Controle Emocional.",
    ],
  },
  stats: {
    title: "Alguns números da PoupaBot",
    subtitle: "Nossa tecnologia trabalhando para você!",
    data: [
      {
        value: "+14",
        description: "Anos de experiência no mercado nacional e internacional.",
      },
      {
        value: "+20,5%",
        description: "O rendimento médio mensal nos últimos 5 anos.",
      },
      {
        value: "5,08x",
        description: "Fator de lucro do portfólio PoupaBot.",
      },
      {
        value: "+85%",
        description: "Meses fechando com resultado positivo.",
      },
      {
        value: "2,24",
        description: "Payoff do portfólio PoupaBot.",
      },
      {
        value: "170x",
        description: "Fator de recuperação do portfólio PoupaBot.",
      },
    ],
  },
  features: {
    title: "Por que utilizar os robôs da PoupaBot?",
    subtitle: "Veja quais as principais vantagens dos robôs da PoupaBot.",
    data: [
      {
        icon: iconsSet.click,
        title: "Facilidade",
        description:
          "Feito para qualquer pessoa com ou sem conhecimento no mercado financeiro. Nossa tecnologia trabalha para você!",
      },
      {
        icon: iconsSet.code,
        title: "Tecnologia",
        description:
          "Nossos robôs proprietários são desenvolvidos com a mais moderna tecnologia, usando modelos quantitativos e baseado em evidências, buscando sempre as melhores operações e constantemente se adaptando às mudanças do mercado.",
      },
      {
        icon: iconsSet.growth,
        title: "Resultados",
        description:
          "Os excelentes resultados constantes ao longo dos anos provam que a sua Independência Financeira está a apenas alguns cliques.",
      },

      ...defaultContent.features.data,
    ],
  },
  plans: {
    title: "Planos",
    subtitle:
      "Conheça os planos da PoupaBot e veja qual se adequa melhor ao seu perfil.",
  },
  testimonials: [
    {
      text: "Com os robôs da PoupaBot eu consegui rentabilizar meu patrimônio de uma forma impressionante, com toda tranquilidade e segurança, sem deixar de exercer minha profissão. Só tenho que agradecer a equipe PoupaBot!",
      author: "Jorge Eduardo Menezes",
      job: "Coordenador de Curso Universitário",
      image_url:
        "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/depoimento_poupabot_jorge.JPG",
    },
    {
      text: "Eu já estava cansada de ficar horas na frente da tela, sofrendo e vendo meu dinheiro desaparecer, até o dia que um amigo apresentou as estratégias da PoupaBot. Hoje não fico mais na frente da tela, tenho tempo livre para cuidar do meu filho e nunca mais tive meu emocional abalado com o mercado, sem falar que ainda posso me dedicar a minha profissão. Fora o atendimento da equipe PoupaBot. São nota dez!",
      author: "Nathália Verônica",
      job: "Engenheira Civil",
      image_url:
        "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/depoimento_poupabot_natalia.JPG",
    },
  ],
};

// https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_algotrading.png
